declare namespace $ {

	type $mol_button_major__sub_shm_hitalama_map_widget_float_code_bench_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_code_bench_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench['run_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_code_bench_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_code_bench_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench['create_view_widget'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_code_bench_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_code_bench_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench['time_passed'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $shm_hitalama_map_widget_float_code_bench_result__state_shm_hitalama_map_widget_float_code_bench_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench['process_state'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_bench_result['state'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_code_bench_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_process_view__host_shm_hitalama_map_widget_float_code_bench_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_bench['process_host'] >
		,
		ReturnType< $shm_hitalama_process_view['host'] >
	>
	type $shm_hitalama_process_view__method_name_shm_hitalama_map_widget_float_code_bench_10 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_process_view['method_name'] >
	>
	export class $shm_hitalama_map_widget_float_code_bench extends $mol_view {
		run_if_enabled( ): any
		Run_icon( ): $mol_icon_play
		run_click( next?: any ): any
		Run( ): $mol_button_major
		run_button( ): readonly(any)[]
		Next_icon( ): $mol_icon_eye
		Next_right_icon( ): $mol_icon_chevron_double_right
		create_view_widget( next?: any ): any
		Create_view_widget( ): $mol_button_minor
		Run_row( ): $mol_view
		time_passed( ): string
		Time( ): $mol_paragraph
		running_fiber_visible( ): readonly(any)[]
		Result_view( ): $shm_hitalama_map_widget_float_code_bench_result
		result_visible( ): readonly(any)[]
		Card( ): $mol_list
		process_host( ): any
		process_state( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_code_bench['Process'] >['state'] >
		started_at( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_code_bench['Process'] >['started_at'] >
		duration( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_code_bench['Process'] >['duration'] >
		widget( ): $shm_hitalama_map_widget
		map( ): $shm_hitalama_map
		Map_page( ): $shm_hitalama_map_page
		context( ): Record<string, any>
		is_atom( ): boolean
		auto( ): readonly(any)[]
		run( ): any
		sub( ): readonly(any)[]
		Process( ): $shm_hitalama_process_view
	}
	
}

//# sourceMappingURL=bench.view.tree.d.ts.map